<script lang="ts">
    import src from './svg/expand_content_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
</script>

<TemplateIcon {src} {scale} alt="Drag" on:click />
